<template>
  <div>
    <outbound-order-list v-show="tabType === 1" @handleShow="handleShow" />
    <outbound-order-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import OutboundOrderList from './list.vue'
import OutboundOrderShow from './show.vue'

export default {
  name: 'OutboundOrder',
  components: { OutboundOrderList, OutboundOrderShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = type === 2 ? { ...row } : null
      this.tabType = type
    }
  }
}
</script>
